import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom'
import { doFetch, clearMe } from '../redux/api/actions';
import { logout } from '../redux/auth/actions';
import { ME } from '../redux/api/constants';
import Error from './auth/error';
import Info from './auth/info';
import Spinner from './auth/spinner';
import { useTranslation } from 'react-i18next';
import { changeLanguage } from '../redux/site/actions';

function UserDropDown({ user }) {
    const dispatch = useDispatch();
    const signout = (e) => {
        e.preventDefault();
        dispatch(logout());
    }
    
    return (
        <li className="nav-item dropdown">
            <button 
                className="btn nav-link dropdown-toggle" 
                id="userDropDownMenu"
                data-bs-toggle="dropdown" 
                aria-expanded="false" 
                aria-label="User menu"
            >
                <i className="bi bi-person-circle me-1"></i>
                {user && user.email}
            </button>
            <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="userDropDownMenu">
                <li>
                    <Link to="/tourguide" className="dropdown-item">
                        <i className="bi bi-speedometer2 me-2"></i>Dashboard
                    </Link>
                </li>
                {user?.is_superuser ? (
                    <>
                        <li>
                            <Link to="/admin" className="dropdown-item">
                                <i className="bi bi-shield-lock me-2"></i>Admin
                            </Link>
                        </li>
                    </>
                ) : null}
                <li><hr className="dropdown-divider" /></li>
                <li>
                    <Link to="/signout" className="dropdown-item" onClick={signout}>
                        <i className="bi bi-box-arrow-right me-2"></i>Logout
                    </Link>
                </li>
            </ul>
        </li>
    )
}

const getFlagEmoji = (languageCode) => {
    switch (languageCode) {
        case 'en': return '🇬🇧';
        case 'it': return '🇮🇹';
        case 'es': return '🇪🇸';
        default: return '🌐';
    }
};

function LanguageDropDown() {
    const dispatch = useDispatch()
    const language = useSelector(state => state.Site.language);
    const { i18n } = useTranslation();
    
    const setLanguage = (language) => {
        dispatch(changeLanguage(language));
    };

    useEffect(() => {
        if (language) {
            i18n.changeLanguage(language);
        }
    }, [language, i18n]);

    return (
        <li className="nav-item dropdown mx-1">
            <button 
                className="btn nav-link dropdown-toggle" 
                id="languageDropdown"
                data-bs-toggle="dropdown" 
                aria-expanded="false" 
                aria-label="Select language"
            >
                {getFlagEmoji(i18n.language)}
            </button>
            <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="languageDropdown">
                <li className="dropdown-item" onClick={() => setLanguage('en')}>🇬🇧 English</li>
                <li className="dropdown-item" onClick={() => setLanguage('it')}>🇮🇹 Italiano</li>
                <li className="dropdown-item" onClick={() => setLanguage('es')}>🇪🇸 Español</li>
            </ul>
        </li>
    )
}

function NavBar({ selected }) {
    const dispatch = useDispatch()
    const accessToken = useSelector(state => state.Auth.accessToken);
    const me = useSelector(state => state.API.me);
    const loading = useSelector(state => state.API.loading);
    const { t } = useTranslation();

    useEffect(() => {
        if (accessToken) {
            dispatch(doFetch(ME, 'users/me', accessToken))
        } else {
            dispatch(clearMe())
        }
    }, [dispatch, accessToken]);

    return (
        <>
            <nav className="navbar navbar-light navbar-expand-md navbar-custom">
                <div className="container">
                    <Link className="navbar-brand" to="/">
                        Torgyd
                    </Link>
                    <button 
                        className="navbar-toggler" 
                        type="button" 
                        data-bs-toggle="collapse" 
                        data-bs-target="#navbarToggler" 
                        aria-controls="navbarToggler" 
                        aria-expanded="false" 
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarToggler">
                        <ul className="navbar-nav ms-auto mb-2 mb-lg-0 d-flex align-items-center">
                            {selected !== "tourguide" && (
                                <li className="nav-item">
                                    <Link 
                                        to="/tourguide/about" 
                                        className="nav-link"
                                    >
                                        {t('become-tourguide')}
                                    </Link>
                                </li>
                            )}
                            
                            {loading ? (
                                <li className="nav-item">
                                    <div className="spinner-border spinner-border-sm text-secondary" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </li>
                            ) : accessToken && me && Object.entries(me).length > 0 ? (
                                <UserDropDown user={me} />
                            ) : (
                                <>
                                    <li className="nav-item">
                                        <Link 
                                            to="/signin" 
                                            className={`nav-link ${selected === "signin" ? "active" : ""}`}
                                        >
                                            {t('signin')}
                                        </Link>
                                    </li>
                                    <li className="nav-item ms-2">
                                        <Link 
                                            to="/signup" 
                                            className="btn btn-outline-dark"
                                        >
                                            {t('signup')}
                                        </Link>
                                    </li>
                                </>
                            )}
                            <LanguageDropDown />
                        </ul>
                    </div>
                </div>
            </nav>
            <Error />
            <Info />
            <Spinner />
        </>
    );
}

export default NavBar;
